import type { ReactNode } from 'react';

/**
 * Шаг внутри экрана онбординга: номер, заголовок и подпись.
 *
 * Экран «Что играем» задаёт четыре разных вопроса подряд (активность, размер, уровень, интересы),
 * и без явных заголовков они читались одним длинным листом: человек не понимал, сколько ещё
 * пунктов и почему кнопка «Дальше» серая.
 */
export function Section({
  n,
  title,
  hint,
  children,
}: {
  n: number;
  title: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-2">
      <div className="flex items-baseline gap-2 px-1">
        <span className="bg-surface-2 text-muted num flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold">
          {n}
        </span>
        <div className="min-w-0">
          <h2 className="text-base font-semibold tracking-tight">{title}</h2>
          {hint ? <p className="text-muted mt-0.5 text-sm">{hint}</p> : null}
        </div>
      </div>
      {children}
    </section>
  );
}
